/* ==========================================================================
   OchreLane — DD+ cup/size picker test. Added 3 Nov 2026.

   Drives snippets/ol-cup-picker.liquid on products whose "Size picker layout"
   field (custom.size_picker_layout) is set:
   - One dropdown (combined): picking "8AU - DD-E Cup" sets the real Bust Size
     and Size selects (rendered hidden) and fires the theme's normal change, so
     price, URL, stock and images update exactly as they do today.
   - Two dropdowns (cup-first): once a cup is chosen, each size shows its cup
     range ("8AU  ·  DD-E cup").
   Both start with nothing chosen. Until a size is chosen, Add to cart is
   disabled and reads "Select your size", Buy it now is inactive, and the
   sticky bar's Add to cart scrolls back to the picker instead of adding.

   The theme re-renders the picker after every change (product-info.js), so
   whether the shopper has chosen yet lives here, per section, and is applied
   again whenever a new picker appears.

   Also exposes OLCupPicker.renderSheet() so the mobile "Select a size" sheet
   (assets/ol-size-sheet.js) lists the same choices.

   Loaded from snippets/js-utilities.liquid on products with the field set.
   ========================================================================== */
(function () {
  'use strict';
  if (window.OLCupPicker) return;

  var chosen = {}; // section id -> { cup, size, focus }

  function config(picker) {
    if (picker._olCfg) return picker._olCfg;
    var script = picker.querySelector('script[data-ol-cup-data]');
    if (!script) return null;
    try { picker._olCfg = JSON.parse(script.textContent); } catch (e) { return null; }
    return picker._olCfg;
  }

  function stateFor(cfg) {
    return chosen[cfg.section] || (chosen[cfg.section] = { cup: false, size: false, focus: null });
  }

  function isComplete(cfg, st) {
    return cfg.layout === 'combined' ? st.size : st.cup && st.size;
  }

  // After a re-render the theme keeps the old picker in the page, hidden, for a moment.
  function isLive(picker) {
    var selects = picker.closest('variant-selects');
    return picker.isConnected && !(selects && selects.style.display === 'none');
  }

  function livePickers(root) {
    return Array.prototype.filter.call((root || document).querySelectorAll('[data-ol-cup-picker]'), isLive);
  }

  function findVariant(cfg, cup, sizeId) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i];
      if (v.cup === cup && String(v.sizeId) === String(sizeId)) return v;
    }
    return null;
  }

  function variantById(cfg, id) {
    for (var i = 0; i < cfg.variants.length; i++) {
      if (String(cfg.variants[i].id) === String(id)) return cfg.variants[i];
    }
    return null;
  }

  function cupOf(option) {
    return /DD/.test(option.value) ? 'dd' : 'ad';
  }

  function optionFor(select, valueId) {
    return Array.prototype.filter.call(select.options, function (o) {
      return o.dataset.optionValueId === String(valueId);
    })[0] || null;
  }

  function markedId(select) {
    var marked = select.querySelector('option[selected]');
    return marked ? marked.dataset.optionValueId : '';
  }

  // Choose a real option the way the theme reads it: variant-selects collects
  // `option[selected]` attributes, not the select's current value. The new option is
  // marked before the old one is unmarked: Safari jumps a select back to its first
  // option when the mark comes off the option it is showing.
  function selectNative(select, valueId) {
    var target = optionFor(select, valueId);
    if (!target) return;
    target.setAttribute('selected', 'selected');
    Array.prototype.forEach.call(select.options, function (o) {
      if (o !== target) o.removeAttribute('selected');
    });
    target.selected = true;
  }

  function promptText(cfg, st) {
    if (cfg.layout === 'combined') return cfg.strings.selectSize;
    return st.cup ? cfg.strings.selectDress : cfg.strings.selectCup;
  }

  function lockButtons(picker, cfg, st) {
    var info = picker.closest('product-info');
    if (!info) return;
    var done = isComplete(cfg, st);
    info.classList.toggle('ol-cup-incomplete', !done);
    // Once a size is chosen the theme has already set the button for that variant.
    if (done) return;
    var button = info.querySelector('[id^="ProductSubmitButton-"]');
    if (!button) return;
    button.setAttribute('disabled', 'disabled');
    (button.querySelector('span') || button).textContent = promptText(cfg, st);
  }

  // Two dropdowns: once a cup is chosen, each size shows that cup's range.
  function labelSizes(sizeSelect, cfg, cup) {
    Array.prototype.forEach.call(sizeSelect.options, function (o) {
      if (!o.dataset.optionValueId) return;
      var label = o.getAttribute('data-ol-label');
      var v = cup ? findVariant(cfg, cup, o.dataset.optionValueId) : null;
      o.disabled = !!cup && !v;
      if (!cup) o.textContent = label;
      else if (!v) o.textContent = label + '  ·  ' + cfg.strings.notAvailable;
      else o.textContent = label + '  ·  ' + v.range + ' cup' + (v.available ? '' : ' · ' + cfg.strings.soldOut);
    });
  }

  function apply(picker) {
    var cfg = config(picker);
    if (!cfg || !isLive(picker)) return;
    var st = stateFor(cfg);

    if (cfg.layout === 'combined') {
      var combined = picker.querySelector('[data-ol-combined]');
      combined.value = st.size && cfg.current ? String(cfg.current) : '';
      if (combined.selectedIndex < 0) combined.value = '';
      combined.classList.toggle('is-empty', !combined.value);
    } else {
      var cupSelect = picker.querySelector('[data-ol-cup-select]');
      var sizeSelect = picker.querySelector('[data-ol-size-select]');
      labelSizes(sizeSelect, cfg, st.cup ? cfg.selectedCup : null);
      if (!st.cup) cupSelect.value = '';
      if (!st.size) sizeSelect.value = '';
      cupSelect.classList.toggle('is-empty', !st.cup);
      sizeSelect.classList.toggle('is-empty', !st.size);
    }

    picker.setAttribute('data-ol-ready', '');
    lockButtons(picker, cfg, st);

    if (st.focus) {
      var field = picker.querySelector(st.focus);
      st.focus = null;
      // Not on phones: iOS reopens the dropdown when a script focuses it.
      if (field && !(window.matchMedia && window.matchMedia('(hover: none)').matches)) field.focus({ preventScroll: true });
    }
  }

  function applyAll() {
    livePickers().forEach(apply);
  }

  function flash(el) {
    if (!el) return;
    el.classList.remove('ol-cup-attn');
    void el.offsetWidth;
    el.classList.add('ol-cup-attn');
    setTimeout(function () { el.classList.remove('ol-cup-attn'); }, 1600);
  }

  function sendToPicker(info) {
    var picker = livePickers(info)[0];
    var cfg = picker && config(picker);
    if (!cfg) return;
    var st = stateFor(cfg);
    var selector = cfg.layout === 'combined' ? '[data-ol-combined]' : st.cup ? '[data-ol-size-select]' : '[data-ol-cup-select]';
    var field = picker.querySelector(selector);
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Some browsers skip smooth scrolling (e.g. reduced motion); jump if it didn't move.
    setTimeout(function () {
      var r = picker.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) picker.scrollIntoView({ block: 'center' });
    }, 700);
    if (!field) return;
    field.focus({ preventScroll: true });
    flash(field.closest('.product-form__input'));
  }

  // Record choices before variant-selects sees the change.
  document.addEventListener('change', function (event) {
    var target = event.target;
    var picker = target && target.closest && target.closest('[data-ol-cup-picker]');
    var cfg = picker && config(picker);
    if (!cfg) return;
    var st = stateFor(cfg);
    var cupSelect = picker.querySelector('[data-ol-cup-select]');
    var sizeSelect = picker.querySelector('[data-ol-size-select]');

    if (target.hasAttribute('data-ol-combined')) {
      // Our own list: keep it from variant-selects and drive the real selects instead.
      event.stopPropagation();
      var v = variantById(cfg, target.value);
      if (!v) return;
      st.cup = st.size = true;
      st.focus = '[data-ol-combined]';
      var cupChanged = markedId(cupSelect) !== String(v.cupId);
      var sizeChanged = markedId(sizeSelect) !== String(v.sizeId);
      if (!cupChanged && !sizeChanged) {
        apply(picker);
        return;
      }
      // The select the change comes from is left as a shopper's change would leave it:
      // the new option chosen, the mark still on the old one. The theme then moves the
      // mark itself (Safari would otherwise reset that select to 6AU, 4 Nov 2026).
      var source = sizeChanged ? sizeSelect : cupSelect;
      if (source !== cupSelect && cupChanged) selectNative(cupSelect, v.cupId);
      optionFor(source, source === sizeSelect ? v.sizeId : v.cupId).selected = true;
      source.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (cfg.layout !== 'cup-first') return;

    var picked = target.selectedOptions[0];
    if (!picked || !picked.dataset.optionValueId) return;

    if (target === cupSelect) {
      st.cup = true;
      st.focus = '[data-ol-cup-select]';
      // Keep the hidden size on one this cup comes in, so the theme doesn't show
      // "Unavailable"; a chosen size that doesn't exist in this cup is cleared.
      var cup = cupOf(picked);
      var size = sizeSelect.querySelector('option[selected]');
      if (size && !findVariant(cfg, cup, size.dataset.optionValueId)) {
        st.size = false;
        var fallback = cfg.variants.filter(function (x) { return x.cup === cup; })[0];
        if (fallback) selectNative(sizeSelect, fallback.sizeId);
      }
      // Show the new ranges straight away rather than after the theme's refresh.
      labelSizes(sizeSelect, cfg, cup);
      if (!st.size) sizeSelect.value = '';
    } else if (target === sizeSelect) {
      st.size = true;
      st.focus = '[data-ol-size-select]';
      // Size picked before a cup: if the default cup doesn't come in this size, switch
      // the hidden cup to one that does.
      if (!st.cup && !findVariant(cfg, cfg.selectedCup, picked.dataset.optionValueId)) {
        var other = findVariant(cfg, cfg.selectedCup === 'dd' ? 'ad' : 'dd', picked.dataset.optionValueId);
        if (other) selectNative(cupSelect, other.cupId);
      }
    } else {
      return;
    }

    // The theme moves the `selected` attribute to the new choice and expects one to exist.
    if (!target.querySelector('option[selected]')) picked.setAttribute('selected', 'selected');
  }, true);

  // Until a size is chosen: the sticky bar's Add to cart and Buy it now send the
  // shopper back to the picker instead of adding the default variant.
  function guard(event) {
    var t = event.target;
    var info = t && t.closest && t.closest('product-info.ol-cup-incomplete');
    if (!info) return;
    var form = t.closest('form');
    if (event.type === 'click' && !t.closest('button[name="add"], .shopify-payment-button')) return;
    if (event.type === 'submit' && !(form && form.querySelector('input[name="id"]'))) return;
    if (form && form.dataset.olQuickAdd) return; // the mobile size sheet already picked a variant
    event.preventDefault();
    event.stopPropagation();
    sendToPicker(info);
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  // Mobile "Select a size" sheet (assets/ol-size-sheet.js).
  function sheetGroup(parent, label) {
    var group = document.createElement('div');
    group.className = 'ol-size-sheet__group';
    if (label) {
      var p = document.createElement('p');
      p.className = 'ol-size-sheet__group-label';
      p.textContent = label;
      group.appendChild(p);
    }
    parent.appendChild(group);
    return group;
  }

  function sheetRow(parent, text, soldOut, onClick) {
    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'ol-size-row' + (soldOut ? ' is-soldout' : '');
    row.textContent = text;
    if (soldOut) row.disabled = true;
    else row.addEventListener('click', onClick);
    parent.appendChild(row);
    return row;
  }

  // Returns the sheet's title, or false when this product isn't in the test.
  function renderSheet(groups, pick) {
    var picker = livePickers()[0];
    var cfg = picker && config(picker);
    if (!cfg) return false;
    groups.innerHTML = '';

    if (cfg.layout === 'combined') {
      var list = sheetGroup(groups, null);
      cfg.variants.forEach(function (v) {
        sheetRow(list, v.label, !v.available, function () { pick(v.id); });
      });
      return cfg.strings.sheetTitleCombined;
    }

    var cupGroup = sheetGroup(groups, cfg.strings.cupSize);
    var sizeGroup = sheetGroup(groups, cfg.strings.dressSize);
    var cup = null;
    var sizes = [];
    cfg.variants.forEach(function (v) {
      if (!sizes.some(function (s) { return s.sizeId === v.sizeId; })) sizes.push({ sizeId: v.sizeId, size: v.size });
    });

    [{ key: 'ad', text: 'A-D cup' }, { key: 'dd', text: 'DD+ cup' }].forEach(function (c) {
      if (!cfg.variants.some(function (v) { return v.cup === c.key; })) return;
      var row = sheetRow(cupGroup, c.text, false, function () {
        cup = c.key;
        Array.prototype.forEach.call(cupGroup.querySelectorAll('.ol-size-row'), function (r) {
          r.classList.toggle('is-selected', r === row);
        });
        drawSizes();
      });
    });

    function drawSizes() {
      Array.prototype.forEach.call(sizeGroup.querySelectorAll('.ol-size-row'), function (r) { r.remove(); });
      sizes.forEach(function (s) {
        var v = cup ? findVariant(cfg, cup, s.sizeId) : null;
        var text = s.size;
        if (cup) text += v ? ' / ' + v.range : '  ·  ' + cfg.strings.notAvailable;
        sheetRow(sizeGroup, text, cup && !(v && v.available), function () {
          if (!cup) { flash(cupGroup); return; }
          pick(v.id);
        });
      });
    }
    drawSizes();
    return cfg.strings.sheetTitleCupFirst;
  }

  window.OLCupPicker = { renderSheet: renderSheet };

  // Pickers appear on load and again after every variant change.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-ol-cup-picker]') || n.querySelector('[data-ol-cup-picker]'))) {
          applyAll();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('variant:change', applyAll);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();
})();
